import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getBusinessProcesses: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES,
	},
	getBusinessProcessesMainInfo: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_MAIN_INFO,
	},
	getBusinessProcessesPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS_POPUP,
	},
	getBusinessProcessesPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS_PREVIEW,
	},
	getBusinessProcess: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS,
	},
	createBusinessProcess: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS,
	},
	patchBusinessProcess: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS,
	},
	putBusinessProcess: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS,
	},
	deleteBusinessProcess: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].DELETE_BUSINESS_PROCESS,
	},
	createBusinessProcessCrop: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS_CROP,
	},
	patchBusinessProcessCrop: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS_CROP,
	},
	putBusinessProcessCrop: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS_CROP,
	},
	multiSetCulture: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].MULTI_SET_CULTURE,
	},

	getBusinessProcessesActiveStages: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGES,
	},
	getBusinessProcessesActiveStage: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE,
	},
	getBusinessProcessesActiveStagePopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE_POPUP,
	},
	getBusinessProcessesActiveStagePreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE_PREVIEW,
	},

	getBusinessProcessesFinanceByCategories: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_CATEGORIES,
	},
	getBusinessProcessesFinanceByDestination: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_DESTINATION,
	},
	getBusinessProcessesFinanceByWorkTypes: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_WORK_TYPES,
	},

	createBusinessProcessUniversal: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS_UNIVERSAL,
	},
	patchBusinessProcessUniversal: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS_UNIVERSAL,
	},
	putBusinessProcessUniversal: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS_UNIVERSAL,
	},
}
